import React, { useEffect, useRef } from 'react';
import ArticleCardBase from '../../Base';
import { inheritChildStyle } from '../../../../../helpers/text';

import './styles.scss';

const PortraitParagraphFull2 = ({ data, endCard }) => {
  const { backgroundColor, header, paragraphC20 } = data;
  const paragraphRef = useRef();

  useEffect(() => {
    if (paragraphRef.current) {
      inheritChildStyle(paragraphRef.current, 'a', 'border-color');
    }
  }, []);

  return (
    <ArticleCardBase variation="portrait" accentColor1={backgroundColor} endCard={endCard}>
      <section className="portrait-paragraph-full-2">
        <div
          className="portrait-paragraph-full-2__header"
          dangerouslySetInnerHTML={{ __html: header }}
        />
        <div
          ref={paragraphRef}
          className="portrait-paragraph-full-2__paragraph"
          dangerouslySetInnerHTML={{ __html: paragraphC20 }}
        />
      </section>
    </ArticleCardBase>
  );
};

export default PortraitParagraphFull2;
